export enum DelfarApiEntity {
    SESSIONS = 'sessions',
    FILES = 'files',
    ORDERS = 'orders',
    SEARCH = 'search',
    HEALTH_PROVIDERS = 'health_providers',
    QRS = 'qrs',
    REFERRALS = 'referrals',
    PHARMACIES = 'pharmacies',
    CUSTOMER_CHATS = 'customer_chats',
    SETTLEMENTS = 'settlements',
    SHIPPING = 'shipping',
}
